import {
  SHOW_SPINNER,
  START_SPINNER_REQUEST,
  FINISH_SPINNER_REQUEST,
} from './types';

export const showSpinnerAction = showSpinner => ({
  type: SHOW_SPINNER,
  showSpinner,
});

export const startSpinnerRequestAction = () => ({
  type: START_SPINNER_REQUEST,
});

export const finishSpinnerRequestAction = () => ({
  type: FINISH_SPINNER_REQUEST,
});
